import { Component, OnInit, ElementRef, ViewChild } from '@angular/core';
import { Title } from '@angular/platform-browser'
import { ReportService } from '../inservice/report.service';
import { PdfService } from '../inservice/pdf.service';
import { CookieService } from '../_services/cookie.service';
import { Utils } from '../_util/utils';
import { HttpClient } from '@angular/common/http';
import { InjectDirective } from '../_directive/inject.directive';
import { CdkDragDrop, moveItemInArray, transferArrayItem } from '@angular/cdk/drag-drop';
import { ActivatedRoute, Router } from '@angular/router';
import { Lightbox } from 'ngx-lightbox';
import Swal from 'sweetalert2';

declare var $: any;

@Component({
  selector: 'app-photolog',
  templateUrl: './photolog.component.html',
  styleUrls: ['./photolog.component.css']
})
export class PhotologComponent implements OnInit {
  logoInfo = [];
  defaultLogo: string; // url
  userInfo: any;
  userId: string;
  userName = "User";
  r: string;
  projectId: string;
  reportId: string;
  photologId: string;

  reportInfo: any;
  addon: string;
  selectedTemplate = "gallery-6";
  selectedHeader = "";
  selectedFooter = "";
  header='';
  footer='';

  editableDefaultText = "Enter text..." // this is for out-of-box templates

  contents: any[];
  appendices = { 'SECTION_SEQUENCE': "", 'SECTION_TITLE': 'APPENDICES', 'SUB_SECTIONS': [] };
  curIndex = [];
  newLibPara = [];
  addedItem: any;

  rPercentage = 0;
  wPercentage = 0;
  uploadFiles = 0;
  uploadTotal = 0;
  uploadNo = 0;
  addLib = false;
  loading = false;
  pdfs = [];
  editOrder = false;

  showDateDirectionLocationChecked = false;
  tempShowDateDirectionLocation = false;

  public logOutFlag = 0;
  public showLogo = 0;
  public current: any;
  public projects = []
  public reports = [];
  public curPhotoLog: any;
  public covers = [];
  public bks = [];
  public others = [];
  public photos = [];
  public logos = [];
  public headers = [];
  public footers = [];
  public uploadedFiles = [];
	private allSlots=[];
  public pageMargin = { 'top': '80', 'bottom': "40", 'left': '20', 'right': '20' };
  public portraitSize = { 'width': '816', 'height': '1056' };
  public landscapeSize = { 'width': '1056', 'height': '816' };
  public selectpage = { 'type': 'portrait', 'size': { 'width': '816', 'height': '1056' } };
  public uploadType: string;
  public photoLog = [];
  public photoTable = [];
  public showNo=true;
  public sortingType='';
  // public sortThumbnail: boolean = false;
  public photoTableColumns = 6;
  acceptType=[];
  @ViewChild(InjectDirective) injectComp: InjectDirective;
  @ViewChild("viewer") viewer: ElementRef;
  @ViewChild("outContent") outContent: ElementRef;
  @ViewChild('file') file: ElementRef;

  constructor(private titleService: Title, private http: HttpClient, public pdfService: PdfService, public reportService:ReportService, private cookieService: CookieService, private router: Router, private route: ActivatedRoute, private lightbox: Lightbox) {
    this.projectId = decodeURI(this.route.snapshot.paramMap.get('project') || '');
    this.reportId = decodeURI(this.route.snapshot.paramMap.get('report') || '');
    this.photologId = decodeURI(this.route.snapshot.paramMap.get('photolog') || '');

    if (this.cookieService.getCookie("userID")) {
      this.userInfo = JSON.parse(this.cookieService.getCookie("userInfo"));
      this.userId = this.cookieService.getCookie("userID");
      this.userName = this.cookieService.getCookie("userName");
      this.r = this.cookieService.getCookie("r");
      this.getAllSlots(this.reportId);
    }
    
		this.acceptType=this.reportService.acceptFileType.split(',');
  }

  getOrderDetail() {
    if (this.cookieService.getCookie("userID")) {
      this.userId = this.cookieService.getCookie("userID");
      this.userName = this.cookieService.getCookie("userName");
      this.r = this.cookieService.getCookie("r");
    } else {
      this.userId = null;
    }
  }

  ngOnInit(): void {
    this.titleService.setTitle("Photo log");
    let w = Math.floor(Utils.mmToPx(279, this.pdfService.dpi));
    let h = Math.floor(Utils.mmToPx(216, this.pdfService.dpi));

    if (this.userId && this.projectId && this.reportId) {
      const uid = parseInt(this.userId);
      const pid = parseInt(this.projectId);
      const rid = parseInt(this.reportId);
      const id = parseInt(this.photologId);

      this.getAllHeader(uid);
      this.getAllFooter(uid);
      this.getLogo();
      this.getRpt(rid);
      this.getPhotoLogs(uid, pid, rid);
    }
  }

  public onInfo(e) {
    this.getOrderDetail();
  }

  onSavedLogo(e) {
    this.showLogo = e;
  }

  onEditReport(e) {
  }

  logOut() {
    this.logOutFlag++;
  }

  getUrl(group, field1, field2, id) {
    let url = "";
    let index = group.findIndex(item => item[field1] == id);
    if (index > -1) {
      url = group[index][field2];
    }
    return url;
  }

  getReports(project, id) {
    let inputJson = { "PROCEDURE": "getreportidsforproject", "USER_ID": id, "PROJECT_ID": project };
    this.pdfService.univeralService(JSON.stringify(inputJson)).subscribe(response => {
      if(response.RESPONSE_STATUS=="N"){
        this.throwError(response)			
      }else{
        this.reports = response.RW_REPORTS;
      this.projects = response.PROJECT_ID;
      }
      
    });
  }

  getAllHeader(id) {
    let inputJson = { "PROCEDURE": "getallheaders", "USER_ID": id };
    this.pdfService.univeralService(JSON.stringify(inputJson)).subscribe(data => {
      if(data.RESPONSE_STATUS=="N"){
        this.throwError(data)			
      }else{
      this.headers = data.RW_HEADERS; //console.log(this.headers)
      }
    });
  }

  getAllFooter(id) {
    let inputJson = { "PROCEDURE": "getallfooters", "USER_ID": id };
    this.pdfService.univeralService(JSON.stringify(inputJson)).subscribe(data => {
      if(data.RESPONSE_STATUS=="N"){
        this.throwError(data)			
      }else{
      this.footers = data.RW_FOOTERS;
      }
    });
  }
  photologurl='';
  getPhotoLogs(id, pid, rid) {
    let inputJson2 = { "PROCEDURE": "getphotosbyreport", "USER_ID": id, "REPORT_ID": rid }
    this.pdfService.univeralService(JSON.stringify(inputJson2)).subscribe(data => {console.log(data)
      if(data.RESPONSE_STATUS=="N"){
        this.throwError(data)			
      }else{
      // get project photos
      this.photos = data.RW_UPLOAD_FILES;
      for (let photo of this.photos) {
        Object.assign(photo, { checked: false, src: photo.FILE_URL, thumb: photo.FILE_TN_URL, caption: photo.FILE_DESCRIPTION });
      }
      // get photo logs
      let inputJson = { "PROCEDURE": "getphotologsbyreport", "USER_ID": id, "REPORT_ID": rid }
      this.pdfService.univeralService(JSON.stringify(inputJson)).subscribe(response => {
        if(response.RESPONSE_STATUS=="N"){
          this.throwError(response)			
        }else{
          this.sortingType=response.SORT_BY;
        if (response.RW_PHOTOLOGS.length > 0) {
          let photologs=response.RW_PHOTOLOGS[0]
          let margin=photologs.MARGIN.split(' ');
          this.pageMargin.top=margin[0];
          this.pageMargin.right=margin[1];
			    this.pageMargin.bottom=margin[2];
		    	this.pageMargin.left=margin[3];
          this.photologId = photologs.PHOTOLOG_ID;
          if (photologs && photologs.HEADER[0] ) {
            this.selectedHeader = photologs.HEADER[0].COPIED_FROM_ID;//HEADER_ID;
            this.header=photologs.HEADER[0].HEADER_ID;
           
          }
          if (photologs && photologs.FOOTER[0])
          {
            this.selectedFooter = photologs.FOOTER[0].COPIED_FROM_ID;//FOOTER_ID;
            this.footer=photologs.FOOTER[0].FOOTER_ID;
          }
          if (photologs.SHOW_PHOTO_NUMBER=='Y')
          {
            this.showNo=true;
          }else{
            this.showNo=false;
          }
          if(photologs.PHOTOLOG_URL&&photologs.PHOTOLOG_URL.length>0){
            this.photologurl=photologs.PHOTOLOG_URL
          }
          if(photologs.PHOTOLOG_DATA){

          
          let photoLog = JSON.parse(photologs.PHOTOLOG_DATA);console.log(photoLog)
          //console.log(photoLog)
          
         
          this.selectedTemplate = photoLog.template;
          this.photoLog = photoLog.photos;

          if (photoLog.usingtpl !== undefined) {
            this.usingtpl = photoLog.usingtpl;
            this.tpl = photoLog.tpl;
            this.reportService.templateModel = photoLog.tplmodel;
          } else {
            this.usingtpl = false;
          }

          if (photoLog.showDateDirectionLocationChecked !== undefined) {
            this.showDateDirectionLocationChecked = photoLog.showDateDirectionLocationChecked;
          }

          this.selectPage(photoLog.orientation);
        }
          for (let i = 0; i < this.photoLog.length; i++) {
            let photo = this.photoLog[i];
            const index = this.photos.findIndex(p => p.FILE_ID == photo.FILE_ID);
            if (index > -1) {
              this.photos[index].checked = true;
            }
          }

          this.initPhotoTable();
        }
      }
      });
    }
    });
  }

  private initPhotoTable() {
    let rows = [];
    let row = [];
    for (let i = 0; i < this.photoLog.length; i++) {
      if (i % this.photoTableColumns == 0 && row.length > 0) {
        rows.push(row);
        row = [];
      }
      row.push(this.photoLog[i]);
    }
    if (row.length > 0) {
      rows.push(row);
      row = [];
    }
    this.photoTable = rows;
  }

  private getLogo() {
    let inputJson = { "PROCEDURE": "getcompanyfiles", "USER_ID": this.userInfo.USER_ID, "FILE_TYPE": "LOGO" };
    this.pdfService.univeralService(JSON.stringify(inputJson)).subscribe(data => {
      if(data.RESPONSE_STATUS=="N"){
        this.throwError(data)			
      }else{
      this.logoInfo = data;
      this.logos = data.RW_UPLOAD_FILES;

      let default_temp = this.logos.find(elem => elem.COMPANY_DEFAULT === 'Y');
      this.defaultLogo = default_temp === undefined? null : default_temp.FILE_URL;
      }
    });
  }

  public preview(alert?) {
    alert = !!alert;
    // this.sortThumbnail = false;
    setTimeout(() => {
      this.generatePdf(alert);
    });
  }

  private async generatePdf(alert) {
    $('#overlay').css('display', 'block');
    let profile='';
		let inputJson={"PROCEDURE":"getcompanyprofile","USER_ID":parseInt(this.userId),"REPORT_ID":this.reportId, "PHOTOLOG_ID": this.photologId};			
		this.reportService.univeralService(JSON.stringify(inputJson)).subscribe(response=>{
      //console.log(response)
      if(response.RESPONSE_STATUS=="Y"){
		    if (!this.usingtpl) {
      let header=response.REPORT_BODY_HEAD;
				profile=atob(header); 
				         //add the fixed a few part to profile 

                profile = "<!DOCTYPE HTML><html><head>" + profile + "</head><body>";
			
			  //	let allhtml=this.getPageData(profile);
        /*
				this.pageMargin.top=response.REPORT_MARGIN_TOP;
				this.pageMargin.bottom=response.REPORT_MARGIN_BOTTOM;
				this.pageMargin.left=response.REPORT_MARGIN_LEFT;
				this.pageMargin.right=response.REPORT_MARGIN_RIGHT;	
        */

      let headerHtml='';
      let footerHtml ='';
      if(response.HEADER&&response.HEADER.HEADER_DATA.length>0){
          headerHtml = this.updateHFDate(response.HEADER.HEADER_DATA, 'header');
      }
      if(response.FOOTER&&response.FOOTER.FOOTER_DATA.length>0){
        footerHtml = this.updateHFDate(response.FOOTER.FOOTER_DATA, 'footer');
      }
     // const footerHtml = this.getHtml(this.footers, 'HEADERFOOTER_ID', 'footer', this.footer);console.log(footerHtml);
     let top=this.pageMargin.top;
      if(headerHtml.length>0){
        top='0';
      }
      let bottom=this.pageMargin.bottom;
      if(footerHtml.length>0){
        bottom='0';
      }
      let html = this.selectpage.type == 'landscape' ? this.pdfService.photoLandscape : this.pdfService.photoPortrait;
      html += this.outContent.nativeElement.innerHTML;
      html += this.pdfService.tagEnd;
      let htmlc = this.pdfService.base64Encode(html);

      let pageMargin = `${top} ${this.pageMargin.right} ${bottom} ${this.pageMargin.left}`;

      this.pdfService.generatePdf(htmlc, this.r, 'Photo Log', '', 'Letter', this.selectpage.type, pageMargin, headerHtml, footerHtml, response.HEADER_LINE, response.FOOTER_LINE).subscribe((result) => {
        $('#overlay').css('display', 'none');
        if (result.rurl) {
          this.savePhotoLog(result.rurl, alert);
        } else {
          Swal.fire({
            icon: 'error',
            title: "Error"
          });
        }
      });      
    
    } else {

      //from xprint:
      // let a4Landscape = `<html><head><style>body{ width: 1054px; margin: 0; font-size: 13px;} .page-after { display: block; page-break-after: always; padding: 10px; }</style></head><body>`;
      // let a4Portrait = `<html><head><style>body{ width: 816px; margin: 0; font-size: 13px;} .page-after { display: block; page-break-after: always; padding: 0 10px; } .wt5 { top: 33px; }</style></head><body>`;
      let a4Landscape = `<html><head><style>body{ width: 1054px; margin: 0; font-size: 13px;}</style></head><body>`;
      let a4Portrait = `<html><head><style>body{ width: 816px; margin: 0; font-size: 13px;}</style></head><body>`;

      let html = this.selectpage.type == 'landscape' ? a4Landscape : a4Portrait;
      // let html = this.selectpage.type == 'landscape' ? this.pdfService.photoLandscape : this.pdfService.photoPortrait;
      html += this.outContent.nativeElement.innerHTML;
      html += this.pdfService.tagEnd;
      let htmlc = this.pdfService.base64Encode(html);

      this.pdfService.generatePdf(htmlc, this.r, 'Photo Log', '', 'Letter', this.selectpage.type, '0 0 0 0', '', '', 'Y', 'Y').subscribe((result) => {
        $('#overlay').css('display', 'none');
        if (result.rurl) {
          this.savePhotoLog(result.rurl, alert);
        } else {
          Swal.fire({
            icon: 'error',
            title: "Error"
          });
        }
      });
    }
  }else{
    $('#overlay').css('display', 'none');
    
      this.throwError(response)			
    
  }
    })
  }
  public upload(type?) {
    if (type) {
      this.uploadType = type;
    }
    if (this.uploadType == 'PHOTO') {
      this.file.nativeElement.click();
    }
  }

  public uploadImage() {
    this.loading = true;
    let that = this;
    this.uploadFiles = 0;
    this.uploadNo = 0;
    const files = this.file.nativeElement.files;

    if (files.length == 0) {
      this.loading = false;
      return
    }
    const total = files.length;
    this.uploadNo = total;
    for (let i = 0; i < files.length; i++) {
      const ext = files[0].name.replace(/.+\./, '');
      if (['png', 'PNG', 'jpg', 'JPG', 'jpeg', 'JPEG'].indexOf(ext) === -1) {
        Swal.fire('Oops...', 'Only support .png|.PNG|.jpg|.JPG|.jpeg|.JPEG', 'error');
        this.loading = false;
        return;
      }
    }
    for (let file of files) {
      const ext = file.name.replace(/.+\./, '');
		if (this.acceptType.indexOf(ext) === -1) {
			Swal.fire('Oops...', ext + ' file Type is not acceptable..');
      this.loading = false;
			return;
		}
      let reader = new FileReader();
      reader.onloadend = function (e) {
        let image = e.target.result.toString().split(',')[1]; //upload service
        let inputJson: any;

        if (that.uploadType == 'PHOTO') {
          inputJson = { "filename": file.name, "user_id": that.userInfo.USER_ID.toString(), "company_id": that.userInfo.COMPANY_ID.toString(), "report_id": that.curPhotoLog.REPORT_ID.toString(), "project_id": that.reportInfo.PROJECT_ID.toString(), "file_desc": "", "file_type": "PHOTO", "filetitle": "", "fdata": image };
          that.pdfService.uploadFile2(inputJson).subscribe(result => {
            that.loading = false;
            if (result.RESPONSE_STATUS=='N') {
              that.throwError(result);
              return										
            }
            Object.assign(result, { checked: false, src: result.FILE_URL, thumb: result.FILE_TN_URL, caption: result.FILE_DESCRIPTION });
            that.photos.push(result);
            that.uploadFiles++
            that.uploadTotal = (that.uploadFiles / total) * 100;
          });
        }
      }
      reader.readAsDataURL(file);
    }
  }

  public selectPage(type) {
    let page: any;
    if (type == 'portrait') {
      page = this.portraitSize;
    } else if (type == 'landscape') {
      page = this.landscapeSize;
    }
    this.selectpage = { 'type': type, 'size': page };
  }

  setPhotoDesc(e, i, type?) {
    let text = e as string;
    this.photoLog[i].FILE_DESCRIPTION = text.length > 100 ? text.substring(0, 99) : text;
    this.savePhotoLog()
    if(type){
      if(i<this.photoLog.length-1){
      let id='#editor'+(i+1).toString();
      //this.scrollPanel('editor'+(i+1).toString());
      $(id).find('.editIcon')[0].click(); 
    }
    }
    
       
  }
   addAllPhotos(event) {
    for (let i = 0; i < this.photos.length; i++) {
      if(event.target.checked){
        let index=this.photoLog.findIndex(item=>item.FILE_ID==this.photos[i].FILE_ID);
        if(index==-1){
          this.photos[i].checked = true; //event.target.checked;
          this.addPhoto(event, i);
        }
      }else{
        this.photos[i].checked = false; //event.target.checked;
        this.photoLog=[];
        //this.addPhoto(event, i);
      }
      
      
    }
  }

  addPhoto(event, i) {
    const index = this.photoLog.findIndex(photo => photo.FILE_ID == this.photos[i].FILE_ID);
    
    if (index > -1) {
      if (event.target.checked) {
        let toadd= JSON.parse(JSON.stringify(this.photos[i]));
        this.photoLog[index] = toadd;
      } else {
        this.photoLog.splice(index, 1);
      }
    } else {
      let toadd= JSON.parse(JSON.stringify(this.photos[i]));
      this.photoLog.push(toadd);
    }
    this.initPhotoTable();
  }

  deletePhoto(i) {
    let photo = this.photoLog[i];
    const index = this.photos.findIndex(p => p.FILE_ID == photo.FILE_ID);
    if (index > -1) {
      this.photos[index].checked = false;
    }
    this.photoLog.splice(i, 1);
    this.initPhotoTable();
  }
  dropPhotolog(e: CdkDragDrop<string[]>) { console.log(e)
    moveItemInArray(this.photoLog, e.previousIndex, e.currentIndex);				
  }
  dropPhoto(event: CdkDragDrop<string[]>) {
    // same row/container? => move item in same row
    if (event.previousContainer === event.container) {
      moveItemInArray(
        event.container.data,
        event.previousIndex,
        event.currentIndex
      );
    } else {
      // different rows? => transfer item from one to another list
      transferArrayItem(
        event.previousContainer.data,
        event.container.data,
        event.previousIndex,
        event.currentIndex
      );
    }

    // update items after drop: flatten matrix into list
    // example: [ [1,2,3], [4,5,6] ] => [1,2,3,4,5,6]
    this.photoLog = this.photoTable.reduce(
      (previous, current) => previous.concat(current),
      []
    );

    // re-initialize table - makes sure each row has same numbers of entries
    // example: [ [1,2], [3,4,5,6] ] => [ [1,2,3], [4,5,6] ]
    this.initPhotoTable();
  }

 /* getPosition(e, i?, j?, k?) {
    let status = $(e.target).hasClass('active');
    if (status) {
      this.curIndex = [this.addon, this.addon, this.addon];
    } else {
      this.curIndex = [i, j, k];
      let posi = "";
      if (k > -1) {
        posi = (i + 1) + '.' + (j + 1) + '.' + (k + 1);
        $('.exDiv1').each(function () {
          $(this).css('display', 'block');
        });
        $('.exDiv2').each(function () {
          $(this).css('display', 'block');
        });
      } else if (j > -1) {
        posi = (i + 1) + '.' + (j + 1);
        $('.exDiv1').each(function () {
          $(this).css('display', 'block');
        });
      } else if (i > -1) {
        posi = (i + 1).toString();
      }
      this.scrollPanel(posi + 'list');
    }
    this.addLib = false;
  }
*/
  scrollPanel(id) {console.log(id)
    let el = document.getElementById(id); console.log(el)
    el.scrollIntoView({ block: "center", inline: "nearest" });
  }

  savePhotoLog(rurl?, alert?) {
    let photoLog = {
      orientation: this.selectpage.type,
      template: this.selectedTemplate,
      header: this.header,
      footer: this.footer,
      usingtpl: this.usingtpl,
      tpl: this.tpl,
      tplmodel: this.reportService.templateModel,
      photos: this.photoLog,
      showDateDirectionLocationChecked: this.tpl === 'r' || this.tpl === 'q' ? this.showDateDirectionLocationChecked : false
    };

    let photoData = JSON.stringify(photoLog);
    let inputJson = {};
    if (this.photologId) {
      if(rurl){
        inputJson = { "PROCEDURE": "updatephotolog", "USER_ID": this.userId, "PHOTOLOG_ID": this.photologId, "PHOTOLOG_TITLE": "", "PHOTOLOG_URL": rurl, "PHOTOLOG_DATA": photoData };
      }else{
        inputJson = { "PROCEDURE": "updatephotolog", "USER_ID": this.userId, "PHOTOLOG_ID": this.photologId, "PHOTOLOG_TITLE": "", "PHOTOLOG_DATA": photoData };
      }
      
    } else {
      if(rurl){
        inputJson = { "PROCEDURE": "insertphotolog", "USER_ID": this.userId, "PROJECT_ID": this.projectId, "REPORT_ID": this.reportId, "PHOTOLOG_TITLE": "", "PHOTOLOG_URL": rurl, "PHOTOLOG_DATA": photoData };
      }else{
        inputJson = { "PROCEDURE": "insertphotolog", "USER_ID": this.userId, "PROJECT_ID": this.projectId, "REPORT_ID": this.reportId, "PHOTOLOG_TITLE": "", "PHOTOLOG_DATA": photoData };
      }
      
    }

    this.pdfService.univeralService(JSON.stringify(inputJson)).subscribe(data => {console.log(data)
      if(data.RESPONSE_STATUS=="N"){
        this.throwError(data)			
      }else{
      if (data.PHOTOLOG_ID) {
        this.photologId = data.PHOTOLOG_ID;
        this.photologurl = data.PHOTOLOG_URL;
        if (alert) {
          Swal.fire({
            icon: 'success',
            title: "Saved"
          });
        }
      } else {
        Swal.fire({
          icon: 'error',
          title: "Error"
        });
      }
    }
    });
  }

  getRpt(id) {
    $('#overlay').css('display', 'block');
    let inputJson = { "PROCEDURE": "getreportdata", "REPORT_ID": id, "USER_ID": parseInt(this.userId), "VERSION_ID": null };// Optional Version_ID - select most recent version if version_id is null

    this.pdfService.univeralService(JSON.stringify(inputJson)).subscribe(data => {
      if (data.ERRORCODE) {
        
          this.throwError(data)			
        
        return
      }
      this.curPhotoLog = data;
      if (data.REPORT_DATA && data.REPORT_DATA.length > 0) {
        this.contents = JSON.parse(data.REPORT_DATA);
        let inputJson1 = { "PROCEDURE": "getreport", "USER_ID": parseInt(this.userId), "REPORT_ID": id };
        this.pdfService.univeralService(JSON.stringify(inputJson1)).subscribe(response => {
          if(response.RESPONSE_STATUS=="N"){
            this.throwError(response)			
          }else{
          this.reportInfo = response; //ORDER_NUM
          /*if (response.HEADER && response.HEADER.length > 0) {
            this.selectedHeader = response.HEADER[0].HEADER_ID;
          }
          if (response.FOOTER && response.FOOTER.length > 0) {
            this.selectedFooter = response.FOOTER[0].FOOTER_ID;
          }*/
                  
          // if (this.reportInfo.ORDER_NUM.length > 0) {
          //   let inputJson2 = { "PROCEDURE": "geterisreportlinks", "USER_ID": parseInt(this.userId), "ORDER_NUM": response.ORDER_NUM }
          //   this.pdfService.univeralService(JSON.stringify(inputJson2)).subscribe(result => {
          //     this.pdfs = result.REPORT_LINKS;

          //   });
          // }
          this.titleService.setTitle("Photo log" + ' - ' + this.reportInfo.REPORT_TITLE);
          if (!this.reportInfo.PERCENT_COMPLETE || this.reportInfo.PERCENT_COMPLETE.length == 0) {
            this.wPercentage = 0;
          } else {
            this.wPercentage = parseFloat(this.reportInfo.PERCENT_COMPLETE);
          }
          if (!this.reportInfo.REVIEWER_PROGRESS || this.reportInfo.REVIEWER_PROGRESS.length == 0) {
            this.rPercentage = 0;
          } else {
            this.rPercentage = parseFloat(this.reportInfo.REVIEWER_PROGRESS);
          }
          $('#overlay').css('display', 'none');
        }
        });

      } else {
        let inputJson1 = { "PROCEDURE": "getreport", "USER_ID": parseInt(this.userId), "REPORT_ID": id };
        this.pdfService.univeralService(JSON.stringify(inputJson1)).subscribe(response => {
          if(response.RESPONSE_STATUS=="N"){
            this.throwError(response)			
          }else{
          this.reportInfo = response;
         /* if (response.HEADER && response.HEADER.length > 0) {
            this.selectedHeader = response.HEADER[0].HEADERFOOTER_ID;
          }
          if (response.FOOTER && response.FOOTER.length > 0) {
            this.selectedFooter = response.FOOTER[0].HEADERFOOTER_ID;
          }*/
          // if (this.reportInfo.ORDER_NUM && this.reportInfo.ORDER_NUM.length > 0) {
          //   let inputJson2 = { "PROCEDURE": "geterisreportlinks", "USER_ID": parseInt(this.userId), "ORDER_NUM": response.ORDER_NUM }
          //   this.pdfService.univeralService(JSON.stringify(inputJson2)).subscribe(result => {
          //     this.pdfs = result.REPORT_LINKS;
          //   });
          // }
          this.titleService.setTitle("Photo log" + ' - ' + this.reportInfo.REPORT_TITLE);
          if (this.reportInfo.PERCENT_COMPLETE && this.reportInfo.PERCENT_COMPLETE.length == 0) {
            this.wPercentage = 0;
          } else {
            this.wPercentage = parseFloat(this.reportInfo.PERCENT_COMPLETE);
          }
          if (this.reportInfo.REVIEWER_PROGRESS && this.reportInfo.REVIEWER_PROGRESS.length == 0) {
            this.rPercentage = 0;
          } else {
            this.rPercentage = parseFloat(this.reportInfo.REVIEWER_PROGRESS);
          }
        }
        });
        $('#overlay').css('display', 'none');
      }
      this.curIndex = [this.addon, this.addon, this.addon];
    });

  }

  deleteFile(item, type) {
    let that = this;
    Swal.fire({
      icon: 'warning',
      title: 'Are you sure you want to delete this item?',
      confirmButtonText: 'Delete',
      showLoaderOnConfirm: true,
      showCancelButton: true,
      backdrop: false,
      preConfirm: () => {
        let inputJson = { "PROCEDURE": "deleteuploadfilev2", "USER_ID": parseInt(that.userId), "FILE_ID": item.FILE_ID };
        this.pdfService.univeralService1(JSON.stringify(inputJson)).subscribe(response => {
          if (JSON.parse(response).RESPONSE_STATUS == "Y") {
            let index = this.photos.findIndex(file => file.FILE_ID == item.FILE_ID);
            if (index > -1) {
              this.photos.splice(index, 1);
            }

            let index2 = this.photoLog.findIndex(file => file.FILE_ID == item.FILE_ID);
            if (index > -1) {
              this.photoLog.splice(index2, 1);
            }
            this.initPhotoTable();
          } else {
            
              this.throwError(response)			
           
          }
        });
      }
    });
  }

  /*updateFile(item, type, e?) {
    let data = $(e.target).prev('textarea').val();
    let inputJson = { "PROCEDURE": "updateuploadfilev2", "USER_ID": 1, "FILE_ID": item.FILE_ID, "FILE_NAME": item.FILE_NAME, "FILE_DESCRIPTION": data };

    this.pdfService.univeralService1(JSON.stringify(inputJson)).subscribe(response => {
      if(response.RESPONSE_STATUS=="N"){
        this.throwError(response)			
      }else{
      let file = JSON.parse(response);
      if (type == 'PHOTO') {
        let index = this.photos.findIndex(photo => photo.FILE_ID == file.FILE_ID);
        if (index > -1) {
          Object.assign(this.photos[index], file);
        }
      }
    }
    });
  }*/
  openEdit(i){
    if(i<this.photos.length-1){
      let id='#photoeditor'+i.toString();
      $(id).find('.editIcon')[0].click(); 
    }
  }
  updateFile(item, type, e, i, type1?) {console.log(type1)
    console.log(item)
    let text = e as string;
    this.photos[i].FILE_DESCRIPTION = text.length > 100 ? text.substring(0, 99) : text;
    let inputJson = { "PROCEDURE": "updateuploadfilev2", "USER_ID": parseInt(this.userId), "FILE_ID": item.FILE_ID, "FILE_NAME": item.FILE_NAME, "FILE_DESCRIPTION": text };
    this.pdfService.univeralService1(JSON.stringify(inputJson)).subscribe(response => {console.log(response)
      if(response.RESPONSE_STATUS=="N"){
        this.throwError(response)			
      }else{console.log(type)
      let file = JSON.parse(response);
      if (type == 'PHOTO') {
        let index = this.photos.findIndex(photo => photo.FILE_ID == file.FILE_ID);console.log(index)
        if (index > -1) {
          Object.assign(this.photos[index], file);console.log(this.photos[index])
          Object.assign(this.photos[index],{ checked: item.checked, src: file.FILE_URL, thumb: file.FILE_TN_URL, caption: file.FILE_DESCRIPTION });
        }
      }
      if(type1){
        let index=i;
       // if(i<this.photos.length-1){
        console.log(this.photos[i])
          if(item.checked){
            for(let j=i+1; j<this.photos.length; j++){
              if (this.photos[j].checked){
                index=j;
                break
              }
            }
          }else{
            for(let j=i+1; j<this.photos.length; j++){
              if (!this.photos[j].checked){
                index=j;
                break
              }
            }
          }
          console.log(i, index)
          //let id='#photoeditor'+(i+1).toString();
          let id='#photoeditor'+index.toString();
          $(id).find('.editIcon')[0].click(); 
        //}
      }
    }
    });
  }

  getPhotoRows() {
    let rows = [];
    let row = [];
    for (let i = 0; i < this.photoLog.length; i++) {
      row.push(this.photoLog[i]);
      if (i % this.photoTableColumns == 0 && row.length > 1) {
        rows.push(row);
        row = [];
      }
    }
    if (row.length > 0) {
      rows.push(row);
      row = [];
    }
    return rows;
  }

  open(index: number): void {
    //this.lightbox.open(this.photos, index);
    this.lightbox.open([this.photos[index]],0);
  }

  close(): void {
    this.lightbox.close();
  }

  public toPhotoTable(photos) {
    let rows = [];
    let row = [];
    let columns = 2;
    if (this.selectpage.type == 'landscape') {
      if (this.selectedTemplate == 'gallery-6') {
        columns = 3;
      }
    }
    if (this.selectpage.type == 'portrait') {
      if (this.selectedTemplate == 'gallery-2') {
        columns = 1;
      }
    }
    for (let i = 0; i < photos.length; i++) {
      if (i % columns == 0 && row.length > 0) {
        rows.push(row);
        row = [];
      }
      row.push(photos[i]);
    }
    if (row.length > 0) {
      for (let p = row.length; p < columns; p++) {
        row.push({});
      }
      rows.push(row);
      row = [];
    }
    return rows;
  }
 
	getHF(id){
		let inputJson2={"PROCEDURE":"getheaderfooterbyid", "USER_ID":parseInt(this.userId), "HEADERFOOTER_ID":id};
		this.reportService.univeralService(JSON.stringify(inputJson2)).subscribe(data => {
      if(data.RESPONSE_STATUS=="N"){
        this.throwError(data)			
      }else{
			if(data.TYPE=="HEADER"){
				let index=this.headers.findIndex(header=>header.HEADERFOOTER_ID==data.HEADERFOOTER_ID);
				if(index>-1){
					this.headers[index]=data;
				}else{			
					this.headers.push(data);
				}					
			}else if(data.TYPE=="FOOTER"){
				let index=this.footers.findIndex(footer=>footer.HEADERFOOTER_ID==data.HEADERFOOTER_ID);
				if(index>-1){
					this.footers[index]=data;
				}else{			
					this.footers.push(data);
				}
								
			}
    }		
		})
	}
	getAllSlots(id){
		//let tempJson={"PROCEDURE":"getslotsbytemplatecategory", "USER_ID":parseInt(this.userId), "TEMPLATE_ID":id};
		let tempJson={"PROCEDURE":"getslotsbyreportnocategory", "USER_ID":parseInt(this.userId), "REPORT_ID":id};
		//console.log(tempJson);
		this.reportService.univeralService(JSON.stringify(tempJson)).subscribe(response => {
			//console.log('slots',response);//templateSlots
			if(response.RESPONSE_STATUS=="N"){
			
				this.allSlots=[];
        
          this.throwError(response)			
        
			}else{
				this.allSlots=response.RW_SLOTS;
			}
		})
	}
	
	getHtml(group, field1,type,id){
		let url="";
		let index=group.findIndex(item=>item[field1]==id);
		if(index>-1){
			let data=group[index];	
			//console.log('urlitem', data);
			let url=this.updateUrl(data,  type);
			return url			
		}
		
		return url;
	}
	updateUrl(data, type){		
		let htmlData='';
		let item:any;
		if(type=='header'||type=='footer'){
			if(data.HF_DATA.length>0){
				item=JSON.parse(data.HF_DATA);
				item.text=this.getRF(item.text);
				if(item.text.length>0){
					let outHFHtml=btoa(encodeURIComponent(item.text).replace(/%([0-9A-F]{2})/g, function (match, p1) {
            return String.fromCharCode(parseInt('0x' + p1, 16));
          }));
					return outHFHtml
				}else{
					return ''
				}
			}else{
				let outHFHtml="";
				return outHFHtml
			}			
		}	
	}
  private updateHFDate(data, type){
    const item=JSON.parse(data);
		item.text=this.getRF(item.text, type);
		if(item.text.length>0){
			let outHFHtml=btoa(encodeURIComponent(item.text).replace(/%([0-9A-F]{2})/g, function (match, p1) {
        return String.fromCharCode(parseInt('0x' + p1, 16));
      }));
	  	return outHFHtml
		}else{
			return ''
		}
  }
	private getRF(data, type?){//console.log(data)
		let that=this;
		let slots=$(data).find('.placeholder'); //console.log('slots',slots);
		if (slots.length==0){
			return data.trim();
		}
		for(let slot of slots){
			const	key=$(slot)[0].innerText; //console.log(key);
			let oldDom=$(slot)[0].outerHTML; //console.log(oldDom);
			let newDom="";
			if(key=='Report Name'){
				newDom=this.reportInfo.REPORT_TITLE; 
			}else{
				let index=that.allSlots.findIndex(slot=>slot.KEY==key);//console.log(index);
				if(index>-1){
					if(that.allSlots[index].CONTENT.length>0){
						newDom=that.allSlots[index].CONTENT
					}
					
				}
			}
     if(newDom.length>0){
				//console.log(data)
				let index=data.indexOf(oldDom); //console.log(index)
				data=data.replace(oldDom, newDom);
			}
		}
		return data;		
	}
  
  tplnames = {
    "k": "Photo 1",
    "l": "Photo 2",
    "q": "Photo 3",
    "r": "Photo 4",
    "s": "Photo 5",
    "t": "Photo 6",
  }
  usingtpl: boolean; // this is true if user is using out-of-box template, false if building their own
  tpls: Array<string> = ["k", "l", "q", "r", "s", "t"]; // these are from xprint, don't know why they're named so poorly but too much work to fix
  tpl: string = null; // k, l, q, r, s, t 
  previewtpl: string = null // k, l, q, r, s, t 
  pickTpl(tpl: string, name: string) {

    if (this.tpl === tpl){
      this.tempShowDateDirectionLocation = this.showDateDirectionLocationChecked;
    }
    else{
      this.tempShowDateDirectionLocation = false;
    }

    this.previewtpl = tpl;

    if (!this.reportService.templateModel) {
      this.reportService.templateModel = {
        name: name,
        type: tpl,
        logo: this.defaultLogo,
        addr: this.reportInfo.FULL_ADDRESS,
        description: this.reportInfo.PROPERTY_NAME,
        no: '#',
        creator: 'jrw',
        date: Utils.format(new Date()),
        note: this.reportInfo.PROPERTY_NAME,
        caption:'Photographic Log',
        pno: this.reportInfo.PROJECT_NUMBER,
        figure: '#',
        projectNameLabel: "Project Name",
        projectLocatioLabel:"Project Location",
        projectionNoLabel:"Project No.",
        figureNoLabel: "Figure No.",
        figureNameLabel:"Figure Name",
      };
    } else if (this.reportService.templateModel.type !== tpl) {
      this.reportService.templateModel.type = tpl;
    }

    $('#templatePreviewModal').modal({backdrop: 'static'}) // makes modal not close when click away
    $('#templatePreviewModal').modal('show');
      
  }

  confirmTpl() {
    /* if (this.tpl != this.previewtpl){
      this.showDateDirectionLocationChecked = false;
    } */
    this.showDateDirectionLocationChecked = this.tempShowDateDirectionLocation;

    this.usingtpl = true; 
    this.tpl = this.previewtpl;

    if (this.tpl === 'r'|| this.tpl === 't') {
      this.selectPage('landscape');
    } else if (this.tpl === 'k'|| this.tpl === 'l' || this.tpl === 'q'|| this.tpl === 's') {
      this.selectPage('portrait');
    }

    if (this.tpl != 'r' && this.tpl != 'q') {
      this.showDateDirectionLocationChecked = false;
    }
    $('#templatePreviewModal').modal('hide');
  }
  saveHeader(){
    let inputJson={"PROCEDURE":"updateheaderforphotolog","USER_ID":parseInt(this.userId),"PHOTOLOG_ID":this.photologId,"HEADER_ID":this.selectedHeader};
    if (this.photologId)
    {
      this.reportService.univeralService(JSON.stringify(inputJson)).subscribe(response => {
        console.log('header',response);
        if(response.RESPONSE_STATUS=="N"){
          
            this.throwError(response)			
          			
        }else{
          this.header=response.HEADERFOOTER_ID;
        }
      })
    }
  
  }
  saveFooter(){
    let inputJson={"PROCEDURE":"updatefooterforphotolog","USER_ID":parseInt(this.userId),"PHOTOLOG_ID":this.photologId,"FOOTER_ID":this.selectedFooter};
    if (this.photologId)
    {
      this.reportService.univeralService(JSON.stringify(inputJson)).subscribe(response => {
        console.log('footer',response);
        if(response.RESPONSE_STATUS=="N"){
          
            this.throwError(response)			
          			
        }else{
        this.footer=response.HEADERFOOTER_ID;
        }
      })
    }
  }
  saveMargin(){
    const pageMargin = `${this.pageMargin.top} ${this.pageMargin.right} ${this.pageMargin.bottom} ${this.pageMargin.left}`;
    if (this.photologId)
    {
      let inputJson={"PROCEDURE":"updatephotolog","USER_ID":parseInt(this.userId),"PHOTOLOG_ID":this.photologId,"MARGIN":pageMargin};
      this.reportService.univeralService(JSON.stringify(inputJson)).subscribe(response => {
        console.log('margin',response);
        if(response.RESPONSE_STATUS=="N"){
         
            this.throwError(response)			
          		
        }else{
          $('#marginModal').modal('hide');
        }
      })
   }
  }
  saveNoConfig(){
    let ifShow="N";
    if(this.showNo){
      ifShow='Y';
    }
    let inputJson={"PROCEDURE":"updatephotolog","USER_ID":parseInt(this.userId),"PHOTOLOG_ID":this.photologId,"SHOW_PHOTO_NUMBER":ifShow};
    console.log(inputJson);
    this.reportService.univeralService(JSON.stringify(inputJson)).subscribe(response => {
      console.log('showNo',response);    
        if(response.RESPONSE_STATUS=="N"){
          this.throwError(response)			
        }
      })
  }
  private throwError(data){
		if(data.RESPONSE_STATUS=='N'&&data.ERRORCODE == '9'){
			console.log('Timeout');
      Swal.fire({
				html: '<p style="font-size:16px; color:red">' + data.MESSAGE.replace('\\n', '<br>') + '</p>',
			})
			this.cookieService.clearAll();
			this.router.navigate(['/']);			
		}else{
			Swal.fire({
				html: '<p style="font-size:16px; color:red">' + data.MESSAGE.replace('\\n', '<br>') + '</p>',
			})
		}
	  }
    rotateImage(image, index){console.log(image)
      let inputJson={	
        "company_id": this.userInfo.COMPANY_ID.toString(),	
        "user_id": this.userInfo.USER_ID.toString(),	
        "file_id": image.FILE_ID,	
        "file_name": image.FILE_NAME,	
        "image_url": image.FILE_URL,
        "SESSION_ID":"",	
        "rotate_angle":90	
      }
      this.reportService.rotateImage(inputJson).subscribe(result => {console.log(result)
        if (result.RESPONSE_STATUS=='N') {
          this.throwError(result);
           return										
        }
          this.photos[index].FILE_TN_URL=result.FILE_TN_URL;
          this.photos[index].FILE_URL=result.FILE_URL;
          this.photos[index].thumb=result.FILE_TN_URL;
          this.photos[index].src=result.FILE_URL;          
      });
    }
    applyto(image){
      let index = this.photoLog.findIndex(file => file.FILE_ID == image.FILE_ID);
      if (index > -1) {
        this.photoLog[index]=JSON.parse(JSON.stringify(image));
        this.savePhotoLog();
      }
    }
    getPhotolog(){
        let inputJson={"PROCEDURE":"getphotologurlforreport","USER_ID":parseInt(this.userId),"REPORT_ID":this.reportId};
        this.reportService.univeralService(JSON.stringify(inputJson)).subscribe(data => {
        if(data.RESPONSE_STATUS=='Y'){
           // let photolog=[{'PHOTOLOG_ID':data.PHOTOLOG_ID, "PHOTOLOG_URL":data.PHOTOLOG_URL}];
           // this.reportInfo['PHOTOLOG_LIST']=photolog;
            let url=data.PHOTOLOG_URL;
            if(url&&url.length>0){
              window.open(url, '_blank');
            }else{
              let data={'MESSAGE':'Photo Log not availble.'};
              this.throwError(data)	
            }
            
           
          }else{
            this.throwError(data)	
          }
        })
      //}
    }
    getSorted(e, src?){
      let type=e.target.value;//console.log(type)
      if(src){
        this.photoLog.sort(function(a, b){
          if (a[type].toUpperCase() < b[type].toUpperCase()) {
            return -1;
          }
          if (a[type].toUpperCase() > b[type].toUpperCase()) {
            return 1;
          }
          return 0;
          //return a[type].toUpperCase() - b[type].toUpperCase();
        });
        //console.log(this.photoLog)
        this.initPhotoTable();
      }else{
        this.sortingType=type;
        let inputJson={"PROCEDURE":"getphotosbyreport","USER_ID":this.userInfo.USER_ID,"REPORT_ID":this.reportId,"SORT_BY":type};console.log(inputJson)
        this.pdfService.univeralService(JSON.stringify(inputJson)).subscribe(data => {console.log(data)
          if(data.RESPONSE_STATUS=="N"){
            this.throwError(data)			
          }else{
            // get project photos
            this.photos = data.RW_UPLOAD_FILES;
            for (let photo of this.photos) {
              Object.assign(photo, { checked: false, src: photo.FILE_URL, thumb: photo.FILE_TN_URL, caption: photo.FILE_DESCRIPTION });
              let index=this.photoLog.findIndex(item=>item.FILE_ID==photo.FILE_ID);
              if(index>-1){
                photo.checked=true;
              }
            }       
          }
        });
      }      
    }
    onDateDirectionLocationChange(checked: boolean){
      this.tempShowDateDirectionLocation = checked;
    }   
}
